import { Dashboard as DashboardIcon } from "@material-ui/icons";
import LandingView from "./views/LandingView";
import ResultsView from "./views/ResultsView";

export const routes = {
  "/": {
    name: "Главная",
    icon: DashboardIcon,
    component: LandingView,
    routes: {},
  },
  "/results": {
    name: "Занятия",
    icon: DashboardIcon,
    component: ResultsView,
    routes: {},
  },
};

export default routes;
